
import { DISABLED_STATUS } from "constants/appConstants";

const isAccountSuspended = (account) => {
  let disabled = false;
  if (account && account.subscription) {
    if (DISABLED_STATUS.indexOf(account.subscription.type) !== -1) {
      disabled = true;
    }
  }

  return disabled;
};

const formatTimeTaken = (time) => {
  if (!time || isNaN(time)) return "0s";

  if (time < 60) return `${Math.floor(time)}s`;
  else if (time < 3600) return `${Math.floor(time / 60)}m`;
  else return `${Math.floor(time / 3600)}h`;
};

export { isAccountSuspended, formatTimeTaken };
